export default "__VITE_ASSET__BpK0w6WO__"